<template>
  <section
    v-if="type !== 'none'"
    class="btn outer-wrapper"
    :class="[className, loading ? 'loading' : '']"
    @click="clickHandler"
    :style="{ background: btnColor.shadow }"
  >
    <!-- :style="{ backgroundImage: `url(${btnBg})` }" -->
    <div
      class="inner-wrapper flex-col-center"
      :style="{ background: btnColor.main }"
    >
      <template v-if="type === 'raffle'">
        <p>{{ text }}</p>
        <div>
          <img
            :src="
              require('@/assets/images/activities/luckydraw/icon-coupon.png')
            "
            alt="icon"
            class="draw-icon"
          />
          <span>× {{ count }}</span>
        </div>
      </template>
      <template v-else>
        <p class="text">{{ text }}</p>
      </template>
    </div>
  </section>
</template>

<script>
  import { trackShowTry10, trackShowGainShots } from '@/pages/Activity/firebase'

  export default {
    props: {
      page: String,
      type: String,
      count: [String, Number],
      text: String,
      btnBg: String,
      btnColor: {
        type: Object,
        default: () => {
          return {
            main: '',
            shadow: '',
          }
        },
      },
      remainingShots: [String, Number],
      upperLimitCount: [String, Number],
      loading: Boolean,
      inPopup: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      className() {
        if (this.type === 'time') {
          // 活动结束
          return 'grey-btn time-over'
        } else if (this.type === 'raffle' && this.count * 1 === 10) {
          if (
            this.remainingShots >= 10 &&
            this.remainingShots <= this.upperLimitCount
          ) {
            // 超过抽奖次数限制或者不够抽奖次数时
            trackShowTry10(this.page, 1) // 可点击的十连抽按钮曝光
            return 'orange-btn breathing-btn'
          } else {
            // 剩余抽奖次数小于 10 的时候按钮需要置灰
            trackShowTry10(this.page, 0)
            return 'grey-btn'
          }
        } else if (this.type === 'raffle' && this.count * 1 === 1) {
          if (
            this.remainingShots >= 1 &&
            this.remainingShots <= this.upperLimitCount
          ) {
            return 'green-btn breathing-btn'
          } else {
            return 'grey-btn'
          }
        } else if (this.type === 'buyShots') {
          // 去下单按钮曝光
          trackShowGainShots(this.page)
          return 'green-btn-long breathing-btn'
        } else {
          // 去登录按钮
          return 'green-btn breathing-btn'
        }
      },
    },
    methods: {
      clickHandler() {
        let data = {}
        data.type = this.type
        if (this.type === 'raffle') {
          data.count = this.count
        }
        this.$emit('clickHandler', data)
      },
    },
  }
</script>

<style scoped lang="scss">
  .btn-wrapper {
    .btn {
      height: 100%;
      font-size: 33px;
      line-height: 40px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      &.loading {
        opacity: 0.7;
      }
      &.has-right-margin {
        margin-right: 25px;
      }
      img.draw-icon {
        width: 32px;
        height: 24px;
        margin-right: 10px;
      }
      &.outer-wrapper {
        height: 144px;
        border-radius: 60px;
        background: rgba(0, 109, 63, 1);
        min-width: 406px;
        max-width: 850px;
        .inner-wrapper {
          height: 125px;
          border-radius: 60px;
          box-sizing: border-box;
          padding: 26px 30px;
          background: linear-gradient(180deg, #00e477 0%, #009c48 100%);
          font-size: 30px;
          font-weight: 600;
          line-height: 40px;
          letter-spacing: 0.03em;
          text-align: center;
        }
      }
    }
    .green-btn-long {
      width: 687px;
      background-size: 100% 100%;
    }
    .grey-btn {
      &.time-over {
        background-size: 100% 100%;
      }
    }
    .text {
      text-align: center;
    }
    &.popup {
      .btn.outer-wrapper {
        height: 100px;
        min-width: 284px;
        max-width: 598px;
        border-radius: 45px;
        .inner-wrapper {
          height: 90px;
          border-radius: 45px;
          font-size: 22px;
          letter-spacing: 0;
          padding: 28px 15px 24px;
        }

        &.has-right-margin {
          margin-right: 20px;
        }
      }
    }
  }
</style>
